<loading-bar *ngIf="loading"></loading-bar>
<loading-bar *ngIf="saving" label="Updating asset"></loading-bar>

<div class="container" *ngIf="!loading && !saving && asset">
    <h2 matTooltip="Serial Number of the asset. Note: the serial number may not be unique for all products">Edit asset
        {{editAssetCommand.serialNumber}}</h2>
    <div class="button-bar">
        <button class="back-button" mat-raised-button color="accent" (click)="cancel()">
            <mat-icon>arrow_back</mat-icon>
            Back
        </button>
    </div>

    <form #assetForm="ngForm">
        <div class="columns-2-rows-3-layout">
            <mat-card class="column1 row1">
                <mat-card-header>
                    <mat-card-title>General</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <p><strong matTooltip="Product Classification ID from ABB Products">CID:</strong> {{ asset.cid }}
                    </p>
                    <p><strong matTooltip="Product highest level parent CID">Family CID:</strong> {{
                        asset.productClassification?.familyCid }}</p>
                    <p><strong matTooltip="CID of the product series">Product Series CID:</strong> {{
                        asset.productClassification?.productSeriesCid }}
                    </p>
                    <p>
                        <strong
                            matTooltip="ABB MasterData Product Name, for MV Drives this is the product subtype (not master data)">
                            Product Series Name:
                        </strong>
                        {{asset.productClassification?.productSeriesName}}
                    </p>
                    <p><strong matTooltip="MIB asset ID">Asset ID:</strong> {{ asset.assetId }}</p>
                    <p>
                        <strong matTooltip="MIB ID or parent asset">Parent Asset ID:</strong>
                        {{asset.parentAssetId}}
                    </p>
                    <p><strong>Global Product ID:</strong> {{ asset.productClassification?.globalProductId }}
                    </p>
                    <p>
                        <strong>Global Product ID Name:</strong>
                        {{asset.productClassification?.globalProductIdname}}
                    </p>
                </mat-card-content>
            </mat-card>

            <mat-card class="column1 row2">
                <mat-card-header>
                    <mat-card-title>Specification</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <mat-form-field matTooltip="Type of Motion Device" class="form-group"
                        appearance="outline">
                        <mat-label for="deviceType">Device Type</mat-label>
                        <mat-select id="deviceType" name="deviceType" [(ngModel)]="editAssetCommand.deviceType">
                            <mat-option *ngFor="let type of deviceTypes" [value]="type">{{ type }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <p><strong matTooltip="Product highest level parent name">Family Name:</strong> {{
                        asset.productClassification?.familyName }}</p>
                    <p><strong matTooltip="ABB Product group name">Product Group Name:</strong> {{
                        asset.productClassification?.productGroupName }}
                    </p>
                    <p><strong matTooltip="Frame size of the product">Frame Size:</strong> {{
                        asset.productClassification?.frameSize }}</p>
                </mat-card-content>
            </mat-card>

            <mat-card class="column1 row3">
                <mat-card-header>
                    <mat-card-title>Manufacturing</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <mat-form-field matTooltip="Date when the asset was manufactured" class="form-group"
                        appearance="outline">
                        <mat-label for="manufacturingDate">Manufacturing Date</mat-label>
                        <input matInput [matDatepicker]="manufacturingDatePicker" id="manufacturingDate"
                            name="manufacturingDate" class="form-control"
                            [(ngModel)]="editAssetCommand.manufacturingDate">
                        <mat-datepicker-toggle matSuffix [for]="manufacturingDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #manufacturingDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date when the asset was shipped from factory" class="form-group"
                        appearance="outline">
                        <mat-label for="deliveryDate">Delivery Date</mat-label>
                        <input matInput [matDatepicker]="deliveryDatePicker" id="deliveryDate" name="deliveryDate"
                            [(ngModel)]="editAssetCommand.deliveryDate" class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #deliveryDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date when a device was commissioned and was ready to be used"
                        class="form-group" appearance="outline">
                        <mat-label for="commissioningDate">Commissioning Date</mat-label>
                        <input matInput [matDatepicker]="commissioningDatePicker" id="commissioningDate"
                            name="commissioningDate" [(ngModel)]="editAssetCommand.commissioningDate"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="commissioningDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #commissioningDatePicker></mat-datepicker>
                    </mat-form-field>

                    <p><strong matTooltip="GUID / ICV of the factory">Manufacturer:</strong> {{
                        asset.manufacturer?.globalId }}</p>
                    <p><strong matTooltip="Local System ID of the ship to company address">Receiving Company:</strong>
                        {{ asset.receivingCompany?.globalId }}</p>
                </mat-card-content>
            </mat-card>

            <mat-card class="column2 row1">
                <mat-card-header>
                    <mat-card-title>Life Cycle</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <mat-form-field matTooltip="Current life cycle phase of device" class="form-group"
                        appearance="outline">
                        <mat-label for="lifeCyclePhase">Life Cycle Phase</mat-label>
                        <mat-select id="lifeCyclePhase" name="lifeCyclePhase" [(ngModel)]="editAssetCommand.lifeCyclePhase">
                            <mat-option *ngFor="let phase of lifeCyclePhases" [value]="phase">{{ phase }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        matTooltip="Name of next life cycle phase. Could be empty as long product is on Active phase"
                        class="form-group" appearance="outline">
                        <mat-label for="nextLifeCyclePhase">Next Life Cycle Phase</mat-label>
                        <mat-select id="nextLifeCyclePhase" name="nextLifeCyclePhase" [(ngModel)]="editAssetCommand.nextLifeCyclePhase">
                            <mat-option *ngFor="let phase of lifeCyclePhases" [value]="phase">{{ phase }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        matTooltip="Date when next life cycle phase becomes current. Could be empty, especially when device is on Active phase"
                        class="form-group" appearance="outline">
                        <mat-label for="nextLifeCyclePhaseDate">Next Life Cycle Phase Date</mat-label>
                        <input matInput [matDatepicker]="nextLifeCyclePhaseDatePicker" id="nextLifeCyclePhaseDate"
                            name="nextLifeCyclePhaseDate" [(ngModel)]="editAssetCommand.nextLifeCyclePhaseDate"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="nextLifeCyclePhaseDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #nextLifeCyclePhaseDatePicker></mat-datepicker>
                    </mat-form-field>

                    <p><strong matTooltip="Email of the person that created asset">Created By:</strong> {{
                        asset.createdBy }}</p>
                    <p><strong matTooltip="Date of the creation of asset">Created Date:</strong> {{ asset.createdDate |
                        mibDateTime }}</p>
                    <p><strong matTooltip="Email of the person that last modified asset">Modified By:</strong> {{
                        asset.modifiedBy }}</p>
                    <p><strong matTooltip="Date of the last modification of asset">Modified Date:</strong> {{
                        asset.modifiedDate | mibDateTime }}</p>
                </mat-card-content>
            </mat-card>

            <mat-card class="column2 row2">
                <mat-card-header>
                    <mat-card-title>Warranty</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <mat-form-field matTooltip="Date when manufacturing unit (factory) warranty starts"
                        class="form-group" appearance="outline">
                        <mat-label for="factoryWarrantyStart">Factory Warranty Start</mat-label>
                        <input matInput [matDatepicker]="factoryWarrantyStartPicker" id="factoryWarrantyStart"
                            name="factoryWarrantyStart" [(ngModel)]="editAssetCommand.factoryWarrantyStart"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="factoryWarrantyStartPicker"></mat-datepicker-toggle>
                        <mat-datepicker #factoryWarrantyStartPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date when manufacturing unit (factory) warranty ends" class="form-group"
                        appearance="outline">
                        <mat-label for="factoryWarrantyEnd">Factory Warranty End</mat-label>
                        <input matInput [matDatepicker]="factoryWarrantyEndPicker" id="factoryWarrantyEnd"
                            name="factoryWarrantyEnd" [(ngModel)]="editAssetCommand.factoryWarrantyEnd"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="factoryWarrantyEndPicker"></mat-datepicker-toggle>
                        <mat-datepicker #factoryWarrantyEndPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date of when Channel's warranty for a customer starts"
                        class="form-group" appearance="outline">
                        <mat-label for="customerWarrantyStart">Customer Warranty Start</mat-label>
                        <input matInput [matDatepicker]="customerWarrantyStartPicker" id="customerWarrantyStart"
                            name="customerWarrantyStart" [(ngModel)]="editAssetCommand.customerWarrantyStart"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="customerWarrantyStartPicker"></mat-datepicker-toggle>
                        <mat-datepicker #customerWarrantyStartPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date of when Channel's warranty for a customer end" class="form-group"
                        appearance="outline">
                        <mat-label for="customerWarrantyEnd">Customer Warranty End</mat-label>
                        <input matInput [matDatepicker]="customerWarrantyEndPicker" id="customerWarrantyEnd"
                            name="customerWarrantyEnd" [(ngModel)]="editAssetCommand.customerWarrantyEnd"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="customerWarrantyEndPicker"></mat-datepicker-toggle>
                        <mat-datepicker #customerWarrantyEndPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date of start of extended warranty" class="form-group"
                        appearance="outline">
                        <mat-label for="extendedWarrantyStart">Extended Warranty Start</mat-label>
                        <input matInput [matDatepicker]="extendedWarrantyStartPicker" id="extendedWarrantyStart"
                            name="extendedWarrantyStart" [(ngModel)]="editAssetCommand.extendedWarrantyStart"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="extendedWarrantyStartPicker"></mat-datepicker-toggle>
                        <mat-datepicker #extendedWarrantyStartPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field matTooltip="Date of end of extended warranty" class="form-group"
                        appearance="outline">
                        <mat-label for="extendedWarrantyEnd">Extended Warranty End</mat-label>
                        <input matInput [matDatepicker]="extendedWarrantyEndPicker" id="extendedWarrantyEnd"
                            name="extendedWarrantyEnd" [(ngModel)]="editAssetCommand.extendedWarrantyEnd"
                            class="form-control">
                        <mat-datepicker-toggle matSuffix [for]="extendedWarrantyEndPicker"></mat-datepicker-toggle>
                        <mat-datepicker #extendedWarrantyEndPicker></mat-datepicker>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>

            <mat-card class="column2 row3">
                <mat-card-header>
                    <mat-card-title>Sales</mat-card-title>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <mat-form-field matTooltip="Sales order id from ordering system" class="form-group"
                        appearance="outline">
                        <mat-label for="salesOrder">Sales Order</mat-label>
                        <input matInput type="text" id="salesOrder" name="salesOrder" maxlength="450"
                            [(ngModel)]="editAssetCommand.salesOrder" class="form-control">
                    </mat-form-field>

                    <mat-form-field matTooltip="Sales order item number" class="form-group" appearance="outline">
                        <mat-label for="salesOrderItem">Sales Order Item</mat-label>
                        <input matInput type="text" id="salesOrderItem" name="salesOrderItem" maxlength="450"
                            [(ngModel)]="editAssetCommand.salesOrderItem" class="form-control">
                    </mat-form-field>

                    <mat-form-field matTooltip="Description of the asset" class="form-group" appearance="outline">
                        <mat-label for="description">Description</mat-label>
                        <textarea matInput id="description" name="description"
                            [(ngModel)]="editAssetCommand.description" maxlength="500"></textarea>
                    </mat-form-field>

                    <p><strong matTooltip="ABB Masterdata - Division Code">Division Code:</strong> {{
                        asset.productClassification?.divisionCode }}</p>
                    <p><strong>Business Unit Code:</strong> {{ asset.productClassification?.businessUnitCode }}
                    </p>
                    <p>
                        <strong
                            matTooltip="GUID of Company known as sales channel for the delivered asset.  OEM, Distributors and similar companies typically act as sales channel and asset in rare cases installed their own facilities.">
                            Channel Partner:</strong>
                        {{ asset.channelPartner?.globalId }}
                    </p>
                    <p><strong matTooltip="Servis Installation ID">ServIs ID:</strong> {{ asset.servIsId }}</p>
                    <p>
                        <strong matTooltip="Product Group Code">
                            Product Classification:</strong>
                        {{ asset.productClassification?.productGroupCode}}
                    </p>
                </mat-card-content>
            </mat-card>
        </div>
    </form>

    <p *ngIf="error" class="error">
        Error: {{ error }}
    </p>

    <div class="button-bar">
        <button mat-raised-button color="accent" (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="update()" class="update-button"
            [disabled]="!assetForm.valid">Update Asset</button>
    </div>
</div>